import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TranslateService } from "@services";
import type { Subscription } from "rxjs";
import { type BadgeStatus, StatusBadgeComponent } from "../status-badge/status-badge.component";
import type { ChallengeStatus } from "../../model";

@Component({
  selector: "app-challenge-status",
  standalone: true,
  imports: [StatusBadgeComponent],
  templateUrl: "./challenge-status.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./challenge-status.component.scss"],
})
export class ChallengeStatusComponent implements OnChanges, OnDestroy {
  @Input({ required: true }) public status: ChallengeStatus;

  public label = "";
  public badgeStatus: BadgeStatus;

  private _statusMap: Record<ChallengeStatus, BadgeStatus> = {
    PASSED: "success",
    ACTIVE: "warning",
    BREACHED: "danger",
    BLOCKED: "danger",
  };

  private _labelSubscription?: Subscription;

  constructor(
    private _translateService: TranslateService,
    private _cdr: ChangeDetectorRef,
  ) {}

  public ngOnChanges(): void {
    this.badgeStatus = this._statusMap[this.status];
    this._labelSubscription?.unsubscribe();
    this._labelSubscription = this._translateService
      .selectTranslationObject(`shared.challengeStatus`)
      .subscribe((label) => {
        this.label = label[this.status];
        this._cdr.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this._labelSubscription?.unsubscribe();
  }
}
